export const DEPT_ACTION = "DEPT_ACTION";


export const deptAction = () => {
    return{
        type: DEPT_ACTION
    }
}